import { Routes ,Route } from "react-router-dom";
import withTenant from './utils/withTenant';
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";


import NotFound from "./NotFound";
import TokenRedirect from "./pages/TokenRedirect";
import Logout from "./pages/Logout";
import HeaderNavBar from "./components/layout/HeaderNavBar";
import Footer from "./components/layout/Footer";
import MenuSide from "./components/layout/MenuSide";
import DashBoard from "./pages/DashBoard";
import withGuard from "./utils/withGuard";
import { useTenant,useStartup } from "./hooks";
import { MwSpinner } from "./components/ui";
import Settiings from "./pages/Settiings";
import { prefetchUrl } from "./hooks/useFetch";

import HomeIncomes from "./pages/incomes/HomeIncomes";
import IncomeAdd from "./pages/incomes/IncomeAdd";
import IncomeEdit from "./pages/incomes/IncomeEdit";
import { IncomesShow } from "./pages/incomes/IncomesShow";
import Homeexpenses from "./pages/expenses/Homeexpenses";
import ExpensesEdit from "./pages/expenses/ExpensesEdit";
import ExpensesAdd from "./pages/expenses/ExpensesAdd";
import { ExpensesShow } from "./pages/expenses/ExpensesShow";
import Reports from "./components/reports/Reports";
import Vendors from "./pages/vendors/Vendors";
import ShowVendor from "./components/Vendors/ShowVendor";
import Customers from "./pages/customers/Customers";
import ShowCustomer from "./components/Customers/ShowCustomer";
// import ExpenseForm from "./pages/expenses/ExpenseForm";
function App() {
  const [openMenu,setOpenMenu] = useState(false);
  const langState = useSelector((state) => state.lang);
  const {tenant,tenantUsername,loading:loadingTenant,companiesList,branchesList,tenantId,companySelected,branchSelected} = useTenant();
  const {startup} = useStartup();

  useEffect(() => {
    if (!startup) return;
    if (!tenantId || !companySelected?.value || !branchSelected?.value) return;
    const taxesUrl = `${process.env.REACT_APP_VAT_WEB_BASE_URL}/sales/taxes/${tenantId}/${companySelected.value}/${branchSelected.value}`;
    prefetchUrl(taxesUrl);
  }, [startup, tenantId, companySelected?.value, branchSelected?.value]);

  return (
    !loadingTenant && startup ? (
      <div dir={langState?.value === 'ar' ? 'rtl' : 'ltr'} className="h-screen flex flex-col flex-between  ">
      <HeaderNavBar
        companySelected = {companySelected}
        branchSelected = {branchSelected}
        companiesList = {companiesList}
        branchesList = {branchesList}
        tenantUsername = {tenantUsername}
        tenant = {tenant}
        openMenu = {openMenu}
        setOpenMenu = {setOpenMenu}
      />
      <div className="bg-white flex  flex-1 ap  m-auto  w-full">
        <MenuSide
          openMenu={openMenu}
          setOpenMenu={setOpenMenu}
          />
      <div className={`flex flex-col flex-1 px-3  py-1 pe-5   primary-bg-color ${openMenu ? 'ms-8 md:ms-0 ps-3' :'md:ms-10'} `}>
      <div className=" rounded-2xl bg-slate-50  h-[calc(100vh-85px)] overflow-scroll">
        
          <Routes >
              <Route path=":tenant/"   element={ <DashBoard/>} />
              <Route path=":tenant/dashboard"   element={ <DashBoard/>} />
              <Route path=":tenant/incomes"   element={ <HomeIncomes/>} />
              <Route path=":tenant/expenses"   element={ <Homeexpenses/>} />
              <Route path=":tenant/vendors" element={<Vendors />} />
              <Route path=":tenant/vendors/show/:id/:companyId/:branchId" element={<ShowVendor />} />
              <Route path=":tenant/customers" element={<Customers />} />
              <Route path=":tenant/customers/show/:id/:companyId/:branchId" element={<ShowCustomer />} />
              <Route path=":tenant/incomes/add/:date" element={ <IncomeAdd/>} />
              <Route path=":tenant/expenses/add/:date" element={ <ExpensesAdd/>} />
              <Route path=":tenant/incomes/add"   element={ <IncomeAdd/>} />
              <Route path=":tenant/expenses/add"   element={ <ExpensesAdd/>} />
              <Route path=":tenant/incomes/edit/:id"   element={ <IncomeEdit/>} />
              <Route path=":tenant/expenses/edit/:id"   element={ <ExpensesEdit/>} />
              <Route path=":tenant/incomes/show/:id"   element={ <IncomesShow/>} />
              <Route path=":tenant/expenses/show/:id"   element={ <ExpensesShow/>} />
              <Route path=":tenant/token/:token" element={<TokenRedirect/>} />
              <Route path=":tenant/settings"   element={!loadingTenant && <Settiings /> } />
              <Route path=":tenant/reports" element={<Reports/>} />
              <Route  path=":tenant/logout"  element={ <Logout/> } />
              <Route path="/notfound"  errorElement={<NotFound/> }  />
              <Route path="/*"  errorElement={<NotFound/> }  />

          </Routes>
        </div>
        </div>
      </div>
      <Footer/>
      </div>
  ) : <MwSpinner/>
  )


}

export default withTenant(withGuard(App));
